(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["silence-private-lease-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll(".spl-calculator");
    const modelLabels = {
      "S04 45 km/u VIVO L6e Unico 1 BP": "SILENCE S04 Unico 1 BP",
      "S04 45 km/u VIVO L6e 85Km range": "SILENCE S04 VIVO 85 km range",
      "S04 45 km/u VIVO L6e 175Km range": "SILENCE S04 VIVO 175 km range",
      "Silence S04 PLUS L7e 85km/u": "SILENCE S04 PLUS L7e 85 km/u"
    };
    const modelOrder = [
      "S04 45 km/u VIVO L6e Unico 1 BP",
      "S04 45 km/u VIVO L6e 85Km range",
      "S04 45 km/u VIVO L6e 175Km range",
      "Silence S04 PLUS L7e 85km/u"
    ];
    const defaultDuration = 48;
    const defaultMileage = 10000;
    const formatter = new Intl.NumberFormat("nl-NL", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    const uniqueNumbers = (values) => [...new Set(values.map(Number))].sort((a, b) => a - b);
    const uniqueModels = (rows) => [...new Set(rows.map((row) => row.type))].sort((a, b) => {
      const aIndex = modelOrder.indexOf(a);
      const bIndex = modelOrder.indexOf(b);
      if (aIndex === -1 && bIndex === -1) return a.localeCompare(b);
      if (aIndex === -1) return 1;
      if (bIndex === -1) return -1;
      return aIndex - bIndex;
    });

    roots.forEach(async (root) => {
      const matrixUrl = root.dataset.splMatrixUrl;
      const form = root.querySelector("form");
      const result = root.querySelector("[data-spl-result]");
      const modelSelect = root.querySelector("[data-spl-model]");
      const durationSelect = root.querySelector("[data-spl-duration]");
      const mileageSelect = root.querySelector("[data-spl-mileage]");
      const submitButton = root.querySelector("[data-spl-submit]");
      const originalSubmitLabel = submitButton ? submitButton.textContent : "";
      const fallbackNotice = root.querySelector("[data-spl-fallback-success]");
      const subjectInput = root.querySelector("[data-spl-subject]");
      const bodyInput = root.querySelector("[data-spl-body]");
      const hiddenModel = root.querySelector("[data-spl-hidden-model]");
      const hiddenDuration = root.querySelector("[data-spl-hidden-duration]");
      const hiddenMileage = root.querySelector("[data-spl-hidden-mileage]");
      const hiddenPrice = root.querySelector("[data-spl-hidden-price]");

      if (!matrixUrl || !form || !result || !modelSelect || !durationSelect || !mileageSelect || !submitButton) return;

      const storageKey = `silencePrivateLeaseQuote:${root.id || window.location.pathname}`;
      const maxStoredQuoteAge = 15 * 60 * 1000;

      const showResult = (message, isError = false) => {
        result.hidden = false;
        result.textContent = message;
        result.classList.toggle("is-error", isError);
      };

      const hideResult = () => {
        result.hidden = true;
        result.textContent = "";
        result.classList.remove("is-error");
      };

      const readStoredQuote = () => {
        try {
          const storedValue = sessionStorage.getItem(storageKey);
          if (!storedValue) return null;
          const quote = JSON.parse(storedValue);
          if (!quote || Date.now() - Number(quote.createdAt || 0) > maxStoredQuoteAge) {
            sessionStorage.removeItem(storageKey);
            return null;
          }
          return quote;
        } catch (error) {
          return null;
        }
      };

      const writeStoredQuote = (quote) => {
        try {
          sessionStorage.setItem(storageKey, JSON.stringify(quote));
        } catch (error) {
        }
      };

      const clearStoredQuote = () => {
        try {
          sessionStorage.removeItem(storageKey);
        } catch (error) {
        }
      };

      let matrix;
      try {
        const matrixResponse = await fetch(matrixUrl, {
          headers: { Accept: "application/json" }
        });
        if (!matrixResponse.ok) throw new Error("Lease matrix asset failed");
        matrix = await matrixResponse.json();
      } catch (error) {
        matrix = null;
      }

      const rows = matrix?.lease_forms?.private_lease_incl_btw?.rows || [];
      const rates = new Map(rows.map((row) => [`${row.type}|${row.looptijd_maanden}|${row.jaarkilometrage}`, row]));

      const renderOptions = (select, values, getLabel, preferredValue) => {
        const currentValue = select.value;
        select.innerHTML = "";
        values.forEach((value) => {
          const option = document.createElement("option");
          option.value = String(value);
          option.textContent = getLabel(value);
          select.append(option);
        });
        const stringValues = values.map(String);
        if (stringValues.includes(String(preferredValue))) {
          select.value = String(preferredValue);
        } else if (stringValues.includes(currentValue)) {
          select.value = currentValue;
        }
      };

      const renderModelOptions = () => {
        modelSelect.innerHTML = "";
        uniqueModels(rows).forEach((type) => {
          const option = document.createElement("option");
          option.value = type;
          option.textContent = modelLabels[type] || type;
          modelSelect.append(option);
        });
      };

      const syncMileages = () => {
        const values = uniqueNumbers(rows.filter((row) => row.type === modelSelect.value && Number(row.looptijd_maanden) === Number(durationSelect.value)).map((row) => row.jaarkilometrage));
        renderOptions(mileageSelect, values, (value) => `${Number(value).toLocaleString("nl-NL")} km`, defaultMileage);
      };

      const syncDurations = () => {
        const values = uniqueNumbers(rows.filter((row) => row.type === modelSelect.value).map((row) => row.looptijd_maanden));
        renderOptions(durationSelect, values, (value) => `${value} maanden`, defaultDuration);
        syncMileages();
      };

      const selectedRate = () => rates.get(`${modelSelect.value}|${durationSelect.value}|${mileageSelect.value}`);
      const selectedModelLabel = () => modelSelect.selectedOptions[0]?.textContent || modelSelect.value;

      const buildQuoteMessage = (priceText, modelLabel, duration, mileage) => {
        return `${priceText} p/m* voor ${modelLabel}, ${duration} maanden en ${Number(mileage).toLocaleString("nl-NL")} km per jaar. Je aanvraag is verzonden naar SILENCE.`;
      };

      const buildQuote = (rate) => {
        const priceText = formatter.format(rate.prijs_per_maand);
        const duration = String(durationSelect.value);
        const mileage = String(mileageSelect.value);
        const modelLabel = selectedModelLabel();
        return {
          model: modelSelect.value,
          modelLabel,
          duration,
          mileage,
          priceText,
          message: buildQuoteMessage(priceText, modelLabel, duration, mileage),
          createdAt: Date.now()
        };
      };

      const updateHiddenFields = (rate) => {
        const durationText = `${durationSelect.value} maanden`;
        const mileageText = `${Number(mileageSelect.value).toLocaleString("nl-NL")} km per jaar`;
        const priceText = formatter.format(rate.prijs_per_maand);
        const lines = [
          "SILENCE Private Lease aanvraag",
          `Model: ${selectedModelLabel()}`,
          `Matrix type: ${modelSelect.value}`,
          `Looptijd: ${durationText}`,
          `Kilometrage: ${mileageText}`,
          `Maandbedrag incl. btw: ${priceText} p/m`,
          `Offertenummer: ${rate.offertenummer}`,
          `Catalogusprijs: ${formatter.format(rate.catalogusprijs)}`
        ];
        subjectInput.value = `SILENCE Private Lease aanvraag - ${selectedModelLabel()}`;
        bodyInput.value = lines.join("\n");
        hiddenModel.value = selectedModelLabel();
        hiddenDuration.value = durationText;
        hiddenMileage.value = mileageText;
        hiddenPrice.value = `${priceText} p/m`;
      };

      if (!rows.length) {
        modelSelect.disabled = true;
        durationSelect.disabled = true;
        mileageSelect.disabled = true;
        submitButton.disabled = true;
        showResult("De lease matrix is niet geladen. Controleer het matrixbestand in assets.", true);
        return;
      }

      renderModelOptions();
      syncDurations();

      const hasOption = (select, value) => {
        return [...select.options].some((option) => option.value === String(value));
      };

      const restoreStoredQuote = () => {
        if (!fallbackNotice) return;
        const quote = readStoredQuote();
        if (!quote) return;
        if (quote.model && hasOption(modelSelect, quote.model)) {
          modelSelect.value = quote.model;
          syncDurations();
        }
        if (quote.duration && hasOption(durationSelect, quote.duration)) {
          durationSelect.value = quote.duration;
          syncMileages();
        }
        if (quote.mileage && hasOption(mileageSelect, quote.mileage)) {
          mileageSelect.value = quote.mileage;
        }
        fallbackNotice.hidden = true;
        showResult(quote.message || buildQuoteMessage(quote.priceText, quote.modelLabel, quote.duration, quote.mileage));
        clearStoredQuote();
      };

      restoreStoredQuote();

      const resetFeedback = () => {
        hideResult();
        clearStoredQuote();
      };

      modelSelect.addEventListener("change", () => {
        resetFeedback();
        syncDurations();
      });
      durationSelect.addEventListener("change", () => {
        resetFeedback();
        syncMileages();
      });
      mileageSelect.addEventListener("change", resetFeedback);

      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        hideResult();
        if (!form.reportValidity()) return;

        const rate = selectedRate();
        if (!rate) {
          showResult("Geen matrixprijs gevonden voor deze combinatie.", true);
          return;
        }

        updateHiddenFields(rate);
        const quote = buildQuote(rate);
        writeStoredQuote(quote);
        submitButton.disabled = true;
        submitButton.textContent = "Aanvraag verzenden...";

        try {
          const response = await fetch(form.action, {
            method: "POST",
            body: new FormData(form),
            headers: { Accept: "text/html" }
          });
          if (!response.ok) throw new Error("Contact form submit failed");
          showResult(quote.message);
        } catch (error) {
          clearStoredQuote();
          showResult("Je aanvraag kon niet worden verzonden. Het maandbedrag blijft verborgen; probeer het opnieuw.", true);
        } finally {
          submitButton.disabled = false;
          submitButton.textContent = originalSubmitLabel;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silence-private-lease"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll(".silence-private-lease");
    const modelLabels = {
      "S04 45 km/u VIVO L6e Unico 1 BP": "SILENCE S04 Unico 1 BP",
      "S04 45 km/u VIVO L6e 85Km range": "SILENCE S04 VIVO 85 km range",
      "S04 45 km/u VIVO L6e 175Km range": "SILENCE S04 VIVO 175 km range",
      "Silence S04 PLUS L7e 85km/u": "SILENCE S04 PLUS L7e 85 km/u"
    };
    const modelOrder = [
      "S04 45 km/u VIVO L6e Unico 1 BP",
      "S04 45 km/u VIVO L6e 85Km range",
      "S04 45 km/u VIVO L6e 175Km range",
      "Silence S04 PLUS L7e 85km/u"
    ];
    const defaultDuration = 48;
    const defaultMileage = 10000;

    const formatMileage = (mileage) => `${Number(mileage).toLocaleString("nl-NL")} km`;
    const formatPrice = (price) => new Intl.NumberFormat("nl-NL", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(price);
    const uniqueNumbers = (values) => [...new Set(values.map(Number))].sort((a, b) => a - b);
    const uniqueModels = (rows) => [...new Set(rows.map((row) => row.type))].sort((a, b) => {
      const aIndex = modelOrder.indexOf(a);
      const bIndex = modelOrder.indexOf(b);
      if (aIndex === -1 && bIndex === -1) {
        return a.localeCompare(b);
      }
      if (aIndex === -1) {
        return 1;
      }
      if (bIndex === -1) {
        return -1;
      }
      return aIndex - bIndex;
    });

    roots.forEach((root) => {
      const matrixElement = root.querySelector("[data-silence-lease-matrix]");
      const form = root.querySelector("form");
      const result = root.querySelector("[data-spl-result]");
      const modelSelect = root.querySelector("[data-spl-model]");
      const durationSelect = root.querySelector("[data-spl-duration]");
      const mileageSelect = root.querySelector("[data-spl-mileage]");
      const emailInput = root.querySelector("[data-spl-email]");
      const submitButton = root.querySelector("[data-spl-submit]");
      const originalSubmitLabel = submitButton ? submitButton.textContent : "";
      const subjectInput = root.querySelector("[data-spl-subject]");
      const bodyInput = root.querySelector("[data-spl-body]");
      const hiddenModel = root.querySelector("[data-spl-hidden-model]");
      const hiddenDuration = root.querySelector("[data-spl-hidden-duration]");
      const hiddenMileage = root.querySelector("[data-spl-hidden-mileage]");
      const hiddenPrice = root.querySelector("[data-spl-hidden-price]");

      if (!matrixElement || !form || !result || !modelSelect || !durationSelect || !mileageSelect || !emailInput || !submitButton) {
        return;
      }

      let matrix;
      try {
        matrix = JSON.parse(matrixElement.textContent);
      } catch (error) {
        matrix = null;
      }

      const rows = matrix?.lease_forms?.private_lease_incl_btw?.rows || [];
      const rates = new Map(rows.map((row) => [`${row.type}|${row.looptijd_maanden}|${row.jaarkilometrage}`, row]));

      const showResult = (message, isError = false) => {
        result.hidden = false;
        result.textContent = message;
        result.classList.toggle("is-error", isError);
        result.scrollIntoView({ behavior: "smooth", block: "nearest" });
      };

      const hideResult = () => {
        result.hidden = true;
        result.textContent = "";
        result.classList.remove("is-error");
      };

      const renderOptions = (select, values, getLabel, preferredValue) => {
        const currentValue = select.value;
        select.innerHTML = "";
        values.forEach((value) => {
          const option = document.createElement("option");
          option.value = String(value);
          option.textContent = getLabel(value);
          select.append(option);
        });

        const desiredValue = values.includes(Number(preferredValue)) ? String(preferredValue) : String(preferredValue || "");
        if (desiredValue && values.map(String).includes(desiredValue)) {
          select.value = desiredValue;
        } else if (currentValue && values.map(String).includes(currentValue)) {
          select.value = currentValue;
        }
      };

      const renderModelOptions = () => {
        modelSelect.innerHTML = "";
        uniqueModels(rows).forEach((type) => {
          const option = document.createElement("option");
          option.value = type;
          option.textContent = modelLabels[type] || type;
          modelSelect.append(option);
        });
      };

      const syncMileages = () => {
        const values = uniqueNumbers(rows.filter((row) => row.type === modelSelect.value && Number(row.looptijd_maanden) === Number(durationSelect.value)).map((row) => row.jaarkilometrage));
        renderOptions(mileageSelect, values, formatMileage, defaultMileage);
      };

      const syncDurations = () => {
        const values = uniqueNumbers(rows.filter((row) => row.type === modelSelect.value).map((row) => row.looptijd_maanden));
        renderOptions(durationSelect, values, (value) => `${value} maanden`, defaultDuration);
        syncMileages();
      };

      const selectedRate = () => rates.get(`${modelSelect.value}|${durationSelect.value}|${mileageSelect.value}`);
      const selectedModelLabel = () => modelSelect.selectedOptions[0]?.textContent || modelSelect.value;

      const updateHiddenFields = (rate) => {
        const durationText = `${durationSelect.value} maanden`;
        const mileageText = `${Number(mileageSelect.value).toLocaleString("nl-NL")} km per jaar`;
        const priceText = formatPrice(rate.prijs_per_maand);
        const lines = [
          "SILENCE Private Lease aanvraag",
          `Model: ${selectedModelLabel()}`,
          `Matrix type: ${modelSelect.value}`,
          `Looptijd: ${durationText}`,
          `Kilometrage: ${mileageText}`,
          `Maandbedrag incl. btw: ${priceText} p/m`,
          `Offertenummer: ${rate.offertenummer}`,
          `Catalogusprijs: ${formatPrice(rate.catalogusprijs)}`
        ];

        subjectInput.value = `SILENCE Private Lease aanvraag - ${selectedModelLabel()}`;
        bodyInput.value = lines.join("\n");
        hiddenModel.value = selectedModelLabel();
        hiddenDuration.value = durationText;
        hiddenMileage.value = mileageText;
        hiddenPrice.value = `${priceText} p/m`;
      };

      if (!rows.length) {
        modelSelect.disabled = true;
        durationSelect.disabled = true;
        mileageSelect.disabled = true;
        submitButton.disabled = true;
        showResult("De lease matrix is niet geladen. Controleer de matrix-snippet.", true);
        return;
      }

      renderModelOptions();
      syncDurations();

      modelSelect.addEventListener("change", () => {
        hideResult();
        syncDurations();
      });

      durationSelect.addEventListener("change", () => {
        hideResult();
        syncMileages();
      });

      mileageSelect.addEventListener("change", hideResult);
      emailInput.addEventListener("input", hideResult);

      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        hideResult();

        if (!form.reportValidity()) {
          return;
        }

        const rate = selectedRate();
        if (!rate) {
          showResult("Geen matrixprijs gevonden voor deze combinatie.", true);
          return;
        }

        updateHiddenFields(rate);
        submitButton.disabled = true;
        submitButton.textContent = "Aanvraag verzenden...";

        try {
          const response = await fetch(form.action, {
            method: "POST",
            body: new FormData(form),
            headers: {
              Accept: "text/html"
            }
          });

          if (!response.ok) {
            throw new Error("Contact form submit failed");
          }

          showResult(`${formatPrice(rate.prijs_per_maand)} p/m* voor ${selectedModelLabel()}, ${durationSelect.value} maanden en ${Number(mileageSelect.value).toLocaleString("nl-NL")} km per jaar. Je aanvraag is verzonden naar SILENCE.`);
        } catch (error) {
          showResult("Je aanvraag kon niet worden verzonden. Het maandbedrag blijft verborgen; probeer het opnieuw.", true);
        } finally {
          submitButton.disabled = false;
          submitButton.textContent = originalSubmitLabel;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
